import * as React from 'react';
import { FormModal } from '../../../components/FormModal';
import { useFormProps } from './hooks/useFormProps';

export const ModalFormContainer: React.FC = () => {
  const props = useFormProps();

  return <FormModal {...props} />;
};
